function updateEntercashCustomAttributes() {
  var selected_country = $('#billing_address_country').val();
  var element = $('#entercash_custom_attributes');
  var countries = ['AT', 'DE'];

  if (countries.indexOf(selected_country) > -1) {
    element.removeClass('hidden');
  } else {
    element.addClass('hidden');
    $('#entercash_transaction_iban').val('');
    $('#entercash_transaction_bic').val('');
  }
}

function listenForEntercashCountryChange() {
  $(function () {
    updateEntercashCustomAttributes();
  });
  $('#billing_address_country').on('change', function () {
    if ($('#entercash_custom_attributes')) {
      updateEntercashCustomAttributes();
    } else {
      return;
    }
  });
}

var Entercash = {
  listenForCountryChange: listenForEntercashCountryChange
};
export default Entercash;